import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import Question from './Question';

const QuestionsList = ({
    questions,
    errors,
    handleChange,
    handleDelete,
    moveItem,
    findItem,
    accountFields,
}) => {
    const ref = useRef(null);

    const [, drop] = useDrop({
        accept: 'question',
        drop: () => {},
    });

    drop(ref);

    return (
        <div ref={ref} className="questions-list">
            {questions.map((question, i) => (
                <Question
                    key={question.questionId || question._id}
                    data={question}
                    errors={errors[question._id]}
                    onChange={(data) => handleChange(data, i)}
                    onDelete={() => handleDelete(i)}
                    moveItem={moveItem}
                    findItem={findItem}
                    accountFields={accountFields}
                />
            ))}
        </div>
    );
};

QuestionsList.propTypes = {
    questions: PropTypes.array.isRequired,
    errors: PropTypes.object,
    handleChange: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    moveItem: PropTypes.func.isRequired,
    findItem: PropTypes.func.isRequired,
    accountFields: PropTypes.array.isRequired,
};

export default QuestionsList;
